import { styled } from 'styled-components';
export const AlertBannerActionArea = styled.div.withConfig({
  displayName: "AlertBannerActionArea",
  componentId: "asurion-ui-react__sc-m3wwln-0"
})(["padding-bottom:1rem;padding-left:1rem;padding-right:1rem;"]);